export function workspaceSyncQueryKey(workspaceId: string | null | undefined) {
  return ["sync", "workspace", workspaceId] as const;
}
